const ga = {
    sendUserId: function() {
        const userId = localStorage.userId;
        if(userId) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'user_id': userId
            });
        }
    },

    sendOfficeLogin: function() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({event: 'login_office'});
    },

    sendPaymentInfo: function() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({event: 'pay_web'});
    },

    sendLastPaymentInfo: function(amount,currency,id,date,payItemId) {
        //do not send old payments. Duplicity for new payments should be filtered by google (with id).
        const paymentDate = new Date(date);
        const now = new Date();
        const maxTime14 = 14 * 24 * 60 * 60 * 1000;
        if(now.getTime() - paymentDate.getTime() <= maxTime14){
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'purchase',
                transaction_id: id,
                value: amount,
                currency: currency,
                items: [
                    {
                        item_id: payItemId,
                        item_name: payItemId
                    }
                ]
            });
        }
    }
}

export default ga;